<template>
  <div>
    <div @click="onClickBalloon">
      <el-card
        class="chatBaloon"
        :class="getBackground(user, currentUser)"
      >
        <div
          class="body"
          v-html="$sanitize(body.replace(/\n/g, '<br/>'))"
        />
        <div class="footer">
          <div class="imgPreview">
            <img
              v-for="(item, index) in images"
              :key="index"
              :src="item"
              alt
              width="80"
              class="attachedImage"
              @click.stop="viewImage(item)"
            />
          </div>
          <div v-for="(fileName, index) in fileName" v-bind:key="index">
            <a
              :download="fileName"
              :target="blankOrDirect[index]"
              :href="fileURL[index]"
              @click.stop
            >
              {{ fileName | decodeFileName }}
            </a>
          </div>
        </div>
      </el-card>
    </div>

    <!-- モーダル > 背景 -->
    <div
      v-if="dialogVisible"
      class="v-modal"
    />

    <!-- モーダル -->
    <el-dialog
      :visible.sync="dialogVisible"
      :modal="false"
    >
      <button class="image_header">
        <div
          class="imageClose"
          @click.stop="dialogVisible = false"
        >
          ✕閉じる
        </div>
        <img
          :src="imgDetail"
          alt
          class="user-dialog-image"
        />
      </button>
    </el-dialog>
  </div>
</template>

<script>
import FileUsecase from "@/usecases/file.usecase";

export default {
  data () {
    return {
      fileURL: [],
      fileName: [],
      blankOrDirect: [],
      dialogVisible: false,
      imgDetail: false,
    };
  },
  props: {
    headerIcon: String,
    headerTitle: String,
    files: Array,
    images: Array,
    body: String,
    currentUser: String,
    user: String,
    isCanceled: Boolean,
    isDeleted: Boolean,
  },
  filters: {
    decodeFileName (fileName) {
      return decodeURI(fileName);
    },
  },
  created () {
    var element = document.getElementById("chatArea");
    element.scrollTop = element.scrollHeight;
    this.getFileProperties();
  },
  components: {},
  methods: {
    onClickBalloon ($event) {
      const {
        user,
        currentUser,
      } = this;

      if (user === currentUser) {
        this.$emit("click", $event);
      }
    },
    async getFileProperties () {
      // ファイルの名前、拡張子、リンクを取得するusecaseを設置し計算結果を取得
      let fileProperties = await usecase.file.getFileProperties(this.files);
      // 各値に代入。
      this.fileName = await fileProperties.fileName;
      this.blankOrDirect = await fileProperties.blankOrDirect;
      this.fileURL = await fileProperties.fileUrl;
    },
    getBackground (userName, currentUser) {
      return userName === currentUser ? "bg-blue" : "bg-gray";
    },
    onClickCheckTablet () {
      const { $router } = this;
      $router.push("/orders/create");
    },
    onClickEdit () {
      const { $router } = this;
      $router.push("/orders/123/edit");
    },
    onClickGoBack () {
      const { $router } = this;
      $router.push("/home");
    },
    viewImage (item) {
      this.dialogVisible = true;
      this.imgDetail = item;
    },
  },

  /**
   * [beforeCreate description]
   */
  beforeCreate () {
    usecase.file = new FileUsecase();
  },

  /**
   * [beforeDestroy description]
   */
  beforeDestroy () {
    Object.keys(usecase).map(key => {
      delete usecase[key];
    });
  },
};

const usecase = {};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";

.chatBaloon {
  margin: 20px 20px 5px 20px;
}
.chatBaloon:first-child {
  margin-top: 0;
}
.header {
  display: flex;
  align-items: center;
}
.column {
  display: flex;
  flex: 1;
  align-items: center;
}
.column-right {
  display: flex;
  justify-content: flex-end;
}
.body {
  text-align: left;
}
.footer {
  text-align: left;
}
.footer .attachedImage {
  cursor: pointer;
}
.attachedImage {
  display: inline-block;
  margin-right: 5px;
}
.user-dialog-image {
  width: auto !important;
  display: block !important;
  cursor: pointer !important;
  max-width: 90% !important;
  margin-left: auto;
  margin-right: auto;
  margin-top: 1.5rem;
}

::v-deep .el-card {
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.1) !important;
}
::v-deep  .el-dialog__wrapper {
  z-index: 2001 !important;
  overflow-x: hidden;
  float: right;
  left: 50%;
}
::v-deep .el-dialog {
// .el-pager li {
  background: none !important;
  -webkit-box-shadow: none;
  box-shadow: none;
}
::v-deep .v-modal {
  z-index: 100 !important;
  left: 50% !important;
}
::v-deep .el-dialog__header {
  padding-top: 0 !important;
  padding-bottom: 0.5rem !important;
}
::v-deep .el-dialog__body {
  padding: 0px 0px 0px 0px !important;
}
::v-deep .el-dialog__headerbtn {
  font-size: 0px;
}
::v-deep .image_header {
  outline: 0;
  background: none;
  border: none;
  margin-left: auto !important;
  margin-right: auto !important;
}
::v-deep .imageClose {
  display: block;
  float: right;
  color: white;
  margin-top: 0rem;
  margin-right: 2.3rem;
  border: none;
  height: 20px;
}
::v-deep .el-dialog {
  width: auto;
  text-align: center;
}

// 管理側・窓口担当メッセージ
.bg-gray {
  background: $--border-color-extra-light !important;
  float: left;
  width: 55%;
}

// 得意先・ユーザメッセージ
.bg-blue {
  background: $blue-light !important;
  float: right;
  width: 55%;
}
</style>
